import React from 'react';
import {Trans} from '@lingui/macro';
import styled from 'styled-components';
import {connect} from 'react-redux';

const Styled = styled.div``;

function StoreOffline() {
    return (
        <Styled>
            <Trans>Store Offline</Trans>
        </Styled>
    );
}

export default connect()(StoreOffline);
